import React, { useState } from 'react';
import { Container, Title } from './filters.styles';
import Categories from './categories';
import PropTypes from 'prop-types';
import { price } from '../hooks/enums';
import PriceFilter from './PriceFilter';

const Filters = ({
  categories,
  filter,
  handleFilter,
  resetFilter,
  seller,
  handlePriceFilter,
  resetPriceFilter,
  lowPrice,
}) => {
  const [visibleItems, setVisibileItems] = useState(5);

  const showMore = () => {
    setVisibileItems(visibleItems + 5);
  };
  return (
    <Container>
      <Title>
        <div className="title">Categories</div>

        {filter !== '' && (
          <div onClick={resetFilter} className="clear">
            Clear all
          </div>
        )}
      </Title>
      <div className="body">
        {categories.slice(0, visibleItems).map((data) => (
          <Categories
            key={data._id}
            categories={data}
            filter={filter}
            handleFilter={handleFilter}
          />
        ))}
        {visibleItems < categories.length ? (
          <div onClick={showMore} className="show">
            Show more{`(${categories.length - visibleItems})`}
          </div>
        ) : (
          <div onClick={() => setVisibileItems(5)} className="show">
            {' '}
            Hide{' '}
          </div>
        )}
      </div>

      <Title style={{ marginTop: 32 }}>
        <div className="title">Price</div>
        {lowPrice !== '' && (
          <div onClick={resetPriceFilter} className="clear">
            Clear all
          </div>
        )}
      </Title>
      <div className="body">
        {price.map((data, idx) => (
          <PriceFilter
            key={idx}
            price={data}
            seller={seller}
            handlePriceFilter={handlePriceFilter}
            lowPrice={lowPrice}
          />
        ))}
      </div>
    </Container>
  );
};

export default Filters;

Filters.propTypes = {
  categories: PropTypes.object.isRequired,
  seller: PropTypes.object.isRequired,
  filter: PropTypes.string.isRequired,
  handleFilter: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
  handlePriceFilter: PropTypes.func.isRequired,
  resetPriceFilter: PropTypes.func.isRequired,
  lowPrice: PropTypes.string.isRequired,
};
